module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/nerve-126cf327c9b43c603a829e2566c48708.png";